import { EventEmitter } from 'events';
import 'whatwg-fetch';

export default class EventFiltersDropdown {

    constructor() {
        this.eventFiltersForm = document.querySelector('.event-filters-search[data-search_endpoint]')

        if (this.eventFiltersForm) {
            const searchEndpoint = this.eventFiltersForm.dataset.search_endpoint

            new FormView(this.eventFiltersForm, searchEndpoint)
        }
    }
}

class FormView extends EventEmitter {

    constructor($formElement, searchEndpoint) {
        super();
        this.$form = $formElement;
        this.searchEndpoint = searchEndpoint;
        this.$inputField = this.$form.querySelector('.event-filters-search-input')
        this.$inputField.addEventListener('keyup', () => this._getLocationsByInput(this.$inputField, this.$inputField.value))
        this.$form.addEventListener('submit', e => this._handleSubmit(e));
    }

    _getLocationsByInput(input, inputValue) {
        const dropdown = this.$form.querySelector('.locator__dropdown');

        if(inputValue.length < 2){
            dropdown.innerHTML = '';
            dropdown.classList.remove('show');
            return;
        }

        // Make an ajax call to the server
        const params = inputValue ? '?query=' + inputValue : '';

        return fetch(this.searchEndpoint + params)
            .then( response => {
                return response.json();
            })
            .then(result => {
                dropdown.innerHTML = '';
                result.forEach(row => {
                    const node = document.createElement("li");
                    const textnode = document.createTextNode(`${row.city}, ${row.province}`);

                    node.appendChild(textnode);
                    node.addEventListener('click', e => {
                        input.value = row.city;

                        dropdown.classList.remove('show');

                        const inputTypeHidden = this.$form.querySelector('input[type="hidden"]')
                        inputTypeHidden.value = row.key

                        const searchButton = document.querySelector('.event-filters-search-button')
                        searchButton.click()
                    });
                    dropdown.appendChild(node);
                })
                dropdown.classList.add('show');
            })
            .catch(ex => {
                console.log('parsing failed', ex);
            });
    }

    _handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();
    }
}